import React from 'react';
import { Box } from '@mui/material';

const MobileCleanInput = ({ placeholder, value, onChange, ...props }) => {
  return (
    <Box
      component="input"
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...props}
      sx={{
        width: '100%',
        padding: '12px 14px',
        fontSize: '16px', // Prevent iOS zoom
        border: '1px solid #bdbdbd',
        borderRadius: '4px',
        outline: 'none',
        backgroundColor: '#f8fafc',
        fontFamily: 'inherit',
        '&:focus': {
          borderColor: '#212F45',
          borderWidth: '2px',
        },
        '&:hover': {
          borderColor: '#212F45',
        },
        // Completely disable validation styling
        '&:invalid': {
          boxShadow: 'none !important',
          borderColor: '#bdbdbd !important',
        },
        '&:required': {
          boxShadow: 'none !important',
        },
        // Hide any pseudo-elements that might show validation
        '&::after, &::before': {
          display: 'none !important',
        },
      }}
      // Force disable validation attributes
      required={false}
      noValidate
      autoComplete="off"
    />
  );
};

export default MobileCleanInput;